import * as CommentsActions from '../comments';
import * as CollaboratorsActions from '../collaborators';
import * as GroupsActions from '../groups';
import * as FilesActions from '../files';
import * as FilerrsActions from '../filerrs';
import * as CurrentActions from '../current';
import * as ShareableLinkActions from '../shareableLink';
import * as CollaboratorsSelectors from '../../selectors/collaborators';
import * as GroupsSelectors from '../../selectors/groups';
import * as FilesSelectors from '../../selectors/files';

export const setDataviewModels = (dataview) => (dispatch) => {
    const { comments, collaborators, groups, files, filerrs, shareableLinks } = dataview;

    dispatch(CommentsActions.setComments(comments));
    dispatch(CollaboratorsActions.setCollaborators(collaborators));
    dispatch(GroupsActions.setGroups(groups));
    dispatch(FilesActions.setFiles(files));
    dispatch(FilerrsActions.setFilerrs(filerrs));
    dispatch(ShareableLinkActions.setShareableLinks(shareableLinks));
};

export const setDataviewCurrents = (payload) => (dispatch, getState) => {
    const groupId = GroupsSelectors.getGroupIdByType(getState(), payload.groupType);
    const collaboratorId = CollaboratorsSelectors.getCurrentCollaboratorIdByGroupId(getState(), groupId);
    const fileId = FilesSelectors.getFileIdByFileFilerrId(getState(), payload.currentFilerrId);

    dispatch(CurrentActions.setCurrentGroupId(groupId));
    dispatch(CurrentActions.setCurrentCollaboratorId(collaboratorId));
    dispatch(CurrentActions.setCurrentFilerrId(payload.currentFilerrId));
    dispatch(CurrentActions.setCurrentFileId(fileId));
};
